<!--
 * @Author: 71
 * @Date: 2026-06-12 15:16:00
 * @LastEditTime: 2026-06-26 17:50:06
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\compoents\model\ActivityEmotionSpaceSection2.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <div class="container">
    <div class="content">
      <!-- 第二部分：学生权益情况 -->
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="24" class="title-1 title-margin flex-between">
          <div>学生权益情况：</div>
        </a-col>
      </a-row>
      
      <!-- 表格整体 -->
      <a-card :bordered="true">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="学校">
                  <a-select
                    allowClear
                    v-model="queryParam.tenantId"
                    v-decorator="[
                      'queryParam.tenantId',
                      { rules: [{ required: true, message: '请选择学校' }] },
                    ]"
                    placeholder="请选择学校"
                    @change="handleTenantChange"
                  >
                    <a-select-option v-for="item in tenantList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="年级">
                  <a-select
                    v-model="queryParam.gradeId"
                    v-decorator="[
                      'queryParam.gradeId',
                      { rules: [{ required: true, message: '请选择年级' }] },
                    ]"
                    placeholder="请选择年级"
                    @change="handleGradeChange"
                    allowClear
                  >
                    <a-select-option v-for="item in gradeList" :key="item.id" :value="item.id">
                      {{ item.gradeName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="班级">
                  <a-select
                    v-model="queryParam.classId"
                    v-decorator="[
                      'queryParam.classId',
                      { rules: [{ required: true, message: '请选择班级' }] },
                    ]"
                    placeholder="请选择班级"
                    allowClear
                  >
                    <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="订单状态">
                  <a-select
                    v-model="queryParam.orderStatus"
                    v-decorator="[
                      'queryParam.orderStatus',
                      { rules: [{ required: true, message: '请选择订单状态' }] },
                    ]"
                    placeholder="请选择订单状态"
                    allowClear
                  >
                    <a-select-option v-for="item in orderStatusList" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="手机号">
                    <a-input placeholder="请输入手机号" v-model="queryParam.phone" allowClear></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="商品名称">
                    <a-input placeholder="请输入商品名称" v-model="queryParam.name" allowClear></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="会员年限">
                    <a-select
                      v-model="queryParam.equityYears"
                      placeholder="请选择会员年限"
                      allowClear
                    >
                      <a-select-option v-for="item in equityYears" :key="item.id" :value="item.name">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="支付方式">
                    <a-select
                      v-model="queryParam.paymentType"
                      placeholder="请选择支付方式"
                      allowClear
                    >
                      <a-select-option v-for="item in paymentTypes" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="会员状态">
                    <a-select
                      v-model="queryParam.memberStatus"
                      v-decorator="[
                        'queryParam.memberStatus',
                        { rules: [{ required: true, message: '请选择会员状态' }] },
                      ]"
                      placeholder="请选择会员状态"
                      allowClear
                    >
                      <a-select-option v-for="item in memberStatusList" :key="item.code" :value="item.code">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="10" :md="12" :sm="24">
                  <a-form-item label="时间范围">
                    <a-range-picker
                      :style="{ 'width': '320px' }"
                      :value="rangeDate"
                      show-time
                      @change="onRangeChange"
                    />
                  </a-form-item>
                </a-col>
                
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                  >
                    重置
                  </a-button>
                  <a-button type="primary" @click="handleExportXls('班级订单')" style="margin-left: 8px">导出</a-button>

                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>

            </a-row>
          </a-form>
        </div>
        <!-- table区域-begin -->
        <div>
          <!-- <div class="table-operator">
            <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          </div> -->
          <a-table
            ref="table"
            size="middle"
            bordered
            :rowKey="(record, index) => index + '_' + record.id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
            </span>
          </a-table>
        </div>
        <!-- table区域-end -->
        
        <!-- 弹窗区域 -->
        <student-membership-modal ref="modalForm" @ok="modalFormOk"></student-membership-modal>
      </a-card>
    </div>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction } from '@/api/manage'
import { TENANT_ID } from "@/store/mutation-types"
import StudentMembershipModal from './StudentMembershipModal.vue'
export default {
  name: 'ActivityEmotionSpacePaneSection2',
  mixins: [JeecgListMixin],
  components: {
    StudentMembershipModal,
  },
  data() {
    return {
      disableMixinCreated: true, // 阻止mixin的created自动执行，由组件统一控制
      rangeDate: null, // 时间范围，会拆分为两个值，beginDate和endDate
      tenantList: [], // 学校列表
      gradeList: [], // 年级列表
      classList0: [], // 缓存最原始的班级列表
      classList: [], // 班级列表
      lastTenantId: null, // 上一次选的
      lastGradeId: null, // 上一次选的
      lastClassId: null, // 上一次选的
      memberStatusList: [
        { code: 0, name: '未开通' },
        { code: 1, name: '试用中' },
        { code: 2, name: '已开通' },
        { code: 3, name: '试用到期' },
        { code: 4, name: '已过期' },
      ], // 会员状态列表
      orderStatusList: [
        { id: 1, name: '已下单未付款' },
        { id: 2, name: '已付款' },
        { id: 3, name: '订单作废' },
      ], // 订单状态列表
      paymentTypes: [
        { id: 1, name: '微信' },
        { id: 2, name: '支付宝' },
      ],
      equityYears:[
        {id:4,name:'半年'},
        {id:1,name:'1年'},
        {id:2,name:'2年'},
        {id:3,name:'3年'}
      ],
      // 表头
      columns: [
        {
          title: '#序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return (this.ipagination.current - 1) * this.ipagination.pageSize + parseInt(index) + 1
          }.bind(this),
        },
        {
          title: '学校',
          align: 'center',
          dataIndex: 'schoolName',
        },
        {
          title: '年级',
          align: 'center',
          dataIndex: 'gradeName',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          customRender: (text) => {
            if (!text) return '-'
            // 手机号脱敏, 例如："13968164016,18042475381,18767173166,18767189281"
            const splitPhones = text.split(',')
            const newPhones = splitPhones.map((item) => item.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') )
            return newPhones.join(', ')
          },
        },
        {
          title: '会员状态',
          align: 'center',
          dataIndex: 'memberStatusStr',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '会员开始日期',
          align: 'center',
          dataIndex: 'validityStartTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '会员到期日期',
          align: 'center',
          dataIndex: 'validityEndTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '商品金额',
          align: 'center',
          dataIndex: 'amount',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '权益年限',
          align: 'center',
          dataIndex: 'equityYears',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '下单时间',
          align: 'center',
          dataIndex: 'orderTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '付款时间',
          align: 'center',
          dataIndex: 'paymentTime',
          customRender: (text) => {
            return text ? text : '-'
          },
        },
        {
          title: '订单状态', // (1-已下单 2-已付款 3-订单作废)
          align: 'center',
          dataIndex: 'orderStatusStr',
          customRender: (text) => {
            return text ? text : '-'
          },
          // dataIndex: 'orderStatus',
          // customRender: (text) => {
          //   const statusMap = {
          //     1: '下单未付款',
          //     2: '下单已付款',
          //     3: '订单作废',
          //   }
          //   return statusMap[text] || text
          // },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 220,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: '/parentalAppStudentFunction/queryStudentOrderPage',
        exportXlsUrl: '/parentalAppStudentFunction/exportStudentOrder',
      },
    }
  },
  async created() {
    await this.loadTenantList() // 等待学校列表加载完成
    this.getCachedTenantId() // 设置默认学校为当前缓存的学校
    this.loadData() // 在设置完默认学校后再加载数据
    this.initDictConfig() // 初始化字典配置
  },
  methods: {
    // 设置默认学校为当前缓存的学校
    getCachedTenantId() {
      const cachedTenantId = this.$ls.get(TENANT_ID)
      if (cachedTenantId) {
        this.$set(this.queryParam, 'tenantId', Number(cachedTenantId))
        // 设置完默认学校后，触发年级和班级列表加载
        this.handleTenantChange(cachedTenantId)
      }
    },
    // 请求获取学校列表
    async loadTenantList() {
      const res = await getAction('/sys/tenant/list', {
        pageNo: 1,
        pageSize: 1000, //TODO 暂时放大单页查询量1000
        order: 'desc',
      })
      console.log(res)
      if (res.success) {
        let records = res.result?.records;
        if (records) {
          records.sort((a,b) => a.name.localeCompare(b.name, 'zh-CN'));
          this.tenantList = records;
        }
      }
    },
    handleTenantChange(value) {
      // 变学校了，清空搜索列
      if (value != this.lastTenantId) {
        this.$set(this.queryParam, 'gradeId', undefined);
        this.$set(this.queryParam, 'classId', undefined);
      }
      this.lastTenantId = value;
      // 获取班级列表， 2025-03-31，建武新增
      getAction('/aigoes/schoolClass/listByTenanId', {
        tenantId: value,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          let classList = res.result;
          if (classList) {
            classList.sort((a,b) => a.name.localeCompare(b.name, 'zh-CN'));
            this.classList0 = classList; 
            this.classList = classList;
          }
        }
      })
      // 获取年级列表， 2025-11-20，建武新增
      getAction('/aigoes/schoolGrade/listByTenanId', {
        tenantId: value,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          let gradeList = res.result;
          if (gradeList) {
            // gradeList.sort((a,b) => a.gradeName.localeCompare(b.gradeName, 'zh-CN'));
            this.gradeList = gradeList;
          }
        }
      })
    },
    handleGradeChange(gradeId) {
      // 变学校了，清空搜索列
      if (gradeId != this.lastGradeId) {
        this.$set(this.queryParam, 'classId', undefined);
      }

      // 清空了年级，恢复所有班级
      if (!gradeId) {
        this.classList = this.classList0;
      } else {
        this.lastGradeId = gradeId;
        // 选学校时已经拿过所有的班级列表了，所以暂时不需要每次都去获取，根据gradeId进行班级列表过滤 
        this.classList = this.classList0.filter(item => item.gradeId==gradeId);
      }
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeDate = dates;
      this.queryParam.beginDate = dateString[0];
      this.queryParam.endDate = dateString[1];
      // this.loadData();
    },
    handleEdit: function (record) {
      this.$refs.modalForm.tenantList = this.tenantList // 先设置学校列表
      this.$refs.modalForm.gradeList = this.gradeList // 先设置年级列表
      this.$refs.modalForm.classList = this.classList // 先设置班级列表
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.edit(record) // 最后打开弹窗
    },
    // handleAdd: function () {
    //   this.$refs.modalForm.tenantList = this.tenantList // 先设置学校列表
    //   this.$refs.modalForm.gradeList = this.gradeList // 先设置年级列表
    //   this.$refs.modalForm.classList = this.classList // 先设置班级列表
    //   this.$refs.modalForm.title = '新增'
    //   this.$refs.modalForm.disableSubmit = false
    //   this.$refs.modalForm.add() // 最后打开弹窗
    // },
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
